"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const aws_common_1 = require("@biorad-lsg-tsc/aws-common");
const crypto_js_1 = __importDefault(require("crypto-js"));
class Encryption {
    static async getEncryptionKey() {
        if (Encryption.encryptionKey == null) {
            const secretsManager = new aws_common_1.SecretsManager();
            const { SecretString } = await secretsManager.getSecret('frontegg-auth');
            const { encryptionKey } = JSON.parse(SecretString);
            Encryption.encryptionKey = encryptionKey;
        }
        return Encryption.encryptionKey;
    }
    static async encryptToken(accessToken) {
        const encryptionKey = await Encryption.getEncryptionKey();
        return crypto_js_1.default.AES.encrypt(accessToken, encryptionKey).toString();
    }
    static async decryptToken(encryptedToken) {
        const encryptionKey = await Encryption.getEncryptionKey();
        const bytes = crypto_js_1.default.AES.decrypt(encryptedToken, encryptionKey);
        return bytes.toString(crypto_js_1.default.enc.Utf8);
    }
}
exports.default = Encryption;
Encryption.encryptionKey = null;
